/**
 * Event system for notifying PublicRunsPage about changes to public run status
 */

type EventListener = (...args: any[]) => void;

class PublicRunsEventEmitter {
  private listeners: { [event: string]: EventListener[] } = {};

  on(event: string, listener: EventListener) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
  }

  off(event: string, listener: EventListener) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter((l) => l !== listener);
  }

  emit(event: string, ...args: any[]) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach((listener) => listener(...args));
  }
}

// Global event emitter instance
export const publicRunsEvents = new PublicRunsEventEmitter();

// Event types
export const PUBLIC_RUNS_EVENTS = {
  RUN_MADE_PUBLIC: 'run_made_public',
  RUN_MADE_PRIVATE: 'run_made_private',
  REFRESH_PUBLIC_RUNS: 'refresh_public_runs',
} as const;
